import * as React from "react";
import { Animate } from "sb-resp-ui";
import { DeviceDetect } from "sb-resp-lib"
import Debounce from "debounce-decorator";
import { observer } from "mobx-react";

/* tslint:disable:cyclomatic-complexity */
/* shouldScroll method creates cyclomatic complexity of 7 */
/* TODO reduce cyclomatic complexity */

@observer
export class Carousel extends React.Component<{
    step?: number
}, {
    scrollable: {
        left: boolean
        right: boolean
    }
    anims: {
        animation: { translateX: number }
        duration: number
        easing: number[]
    }
    deviceType: DeviceDetect
}>
{
    calcs: {
        container: number
        wrapper: number
        step: number
    }
    anims: { left: number }

    wrapper!: HTMLDivElement | null
    container!: HTMLDivElement | null

    rtl: boolean

    constructor(props)
    {
        super(props);

        this.calcs = {
            step: 0,
            container: 0,
            wrapper: 0
        }
        this.anims = { left: 0 }
        this.state = {
            scrollable: {
                left: false,
                right: false
            },
            anims: { animation: { translateX: 0 }, duration: 600, easing: [10, 5] },
            deviceType: DeviceDetect.getInstance()
        }
        this.rtl = document.dir === "rtl" ? true : false;
    }

    /* istanbul ignore next */
    scrollLeft()
    {
        if (this.state.scrollable.left)
        {
            const l = this.anims.left + this.calcs.step;
            this.anims.left = l > 0 ? 0 : l;
            const o = { ...this.state.anims, animation: { translateX: (this.rtl ? -1 : 1) * this.anims.left} }
            this.setState({ anims: { ...o } });
        }
    }

    /* istanbul ignore next */
    scrollRight()
    {
        if (this.state.scrollable.right)
        {
            const t = this.anims.left - this.calcs.step;
            const d = this.calcs.container - this.calcs.wrapper;
            this.anims.left = Math.abs(t) > d ? d * -1 : t;
            const o = { ...this.state.anims, animation: { translateX: (this.rtl ? -1 : 1) * this.anims.left } }
            this.setState({ anims: { ...o } });
        }
    }

    setupCalcs()
    {
        if (this.wrapper && this.container) {
            this.calcs.step = (this.props.step && this.props.step < this.wrapper.offsetWidth) ? this.props.step : this.wrapper.offsetWidth;
            this.calcs.wrapper = this.wrapper.offsetWidth;
            this.calcs.container = this.container.offsetWidth;
        }
    }

    shouldScroll()
    {

        if (this.wrapper && this.container) {

            const sLeft = this.anims.left < 0 ? true : false;
            const sRight = this.calcs.container - this.calcs.wrapper + this.anims.left > 0 ? true : false;
            if (
                this.state.scrollable.left !== sLeft ||
                this.state.scrollable.right !== sRight
            ) {
                this.setState({
                    scrollable: {
                        left: sLeft,
                        right: sRight
                    }
                })
            }
        }
    }

    /* istanbul ignore next */
    @Debounce(50)
    scrollWheel(e)
    {
        if (e.deltaY < 0) {
            this.scrollLeft();
        } else {
            this.scrollRight();
        }
    }

     /* istanbul ignore next */
    @Debounce(50)
    resetScroll()
    {
        this.anims.left = 0;
        this.setState({ anims: { ...this.state.anims, animation: { translateX: 0 } } });
    }

     /* istanbul ignore next */
    @Debounce(50)
    handleEvent(e: Event)
    {
        if (e.type === "resize")
        {

            this.resetScroll();

            if (this.state.deviceType.isDesktop)
            {
                this.setupCalcs();
                this.shouldScroll();
            }
        }
    }

     /* istanbul ignore next */
    @Debounce(50)
    onClickArrowsHandler(direction: string)
    {
        this["scroll" + direction]();
        this.shouldScroll();
    }

    updateScrollPosition()
    {
        this.shouldScroll();
        const o = { ...this.state.anims, animation: { translateX: this.anims.left } }
        this.setState({ anims: { ...o } });
    }

    componentDidMount()
    {
        if (this.state.deviceType.isDesktop)
        {
            this.setupCalcs();
            this.shouldScroll();
            window.addEventListener("resize", this);
            this.container && this.container.addEventListener("wheel", this.scrollWheel.bind(this));
        }
        else
        {
            this.resetScroll();
        }
    }

    componentDidUpdate(prevProps, prevState)
    {
        this.setupCalcs();
        this.shouldScroll();
    }

    render()
    {
        let cls = "rj-carousel";
        cls += this.state.scrollable.left ? " rj-carousel--sLeft" : "";
        cls += this.state.scrollable.right ? " rj-carousel--sRight" : "";
        return (
            <div className={cls}  ref={n => this.wrapper = n}>

                {(this.state.deviceType.isDesktop) &&
                    (
                    <div className="rj-carousel-arrow rj-carousel-arrow-left" onClick={this.onClickArrowsHandler.bind(this, "Left")}>
                        <div className="rj-carousel-arrow--inner"></div>
                    </div>
                    )}
                {(this.state.deviceType.isDesktop) &&
                    (
                    <div className="rj-carousel-arrow rj-carousel-arrow-right" onClick={this.onClickArrowsHandler.bind(this, "Right")}>
                        <div className="rj-carousel-arrow--inner"></div>
                    </div>
                )}
                <Animate {...this.state.anims}>
                    <div className="rj-carousel-container" ref={n => this.container = n}>
                        {this.props.children}
                    </div>
                </Animate>
            </div>
        )
    }
}